import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import PortalCommunication from '../../portal-comms';

export function* downloadTemplateRollover() {
    const response = yield call(api.downloadTemplateFile, { templateType: 'rollover' });
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.downloadRolloverTemplateSuccess(downloadUrl, false));
    } else {
        yield put(actions.downloadRolloverTemplateFailure());
    }
}

export function* downloadTemplateForRolloverSaga() {
    yield takeLatest(actions.DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST, downloadTemplateRollover);
}

export function* downloadSchoolRollDataRollover({ productId, includeUnassignedStudents, includeBulkTransfer }) {
    const response = yield call(api.downloadSchoolRollData, productId, includeUnassignedStudents, includeBulkTransfer);
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url.slice(0, response.verb.url.indexOf('?'))}/${response.data}`;
        yield put(actions.downloadSchoolRollDataRolloverSuccess(downloadUrl));
    } else {
        yield put(actions.downloadSchoolRollDataRolloverFailure());
    }
}

export function* downloadSchoolRollDataRolloverSaga() {
    yield takeLatest(actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST, downloadSchoolRollDataRollover);
}

export function* rollOverVerifyContent({ productId, fileContent }) {
    const response = yield call(api.verifyRollover, productId, fileContent);
    if (response.status === 200) {
        yield put(actions.rollOverVerifyContentSuccess(response.data));
    } else if (response.status === 400) {
        yield put(actions.rollOverVerifyContentFailure(response.message, true));
    } else {
        yield put(actions.rollOverVerifyContentFailure('', false));
    }
}

export function* rollOverVerifyContentSaga() {
    yield takeLatest(actions.ROLLOVER_VERIFY_FILE_CONTENT_REQUEST, rollOverVerifyContent);
}

export function* performRollOver({ rolloverType, productId, rolloverItems }) {
    const schoolRollover = { rolloverItems, rolloverType };
    const response = yield call(api.performRollover, productId, schoolRollover);
    if (response.status === 200) {
        PortalCommunication.informMakeAPICall({
            productId,
            apiType: 'Notification'
        });
        yield put(actions.onRollOverConfirmationSuccess(response.data, productId));
    } else {
        const { message } = response;
        yield put(actions.onRollOverConfirmationFailure(false, message));
    }
}

export function* performRollOverSaga() {
    yield takeLatest(actions.ON_ROLLOVER_CONFIRMATION_REQUEST, performRollOver);
}

export function* downloadRolloverSignInCards({ productId, userIds, userType, format }) {
    let response = {};
    if (userType === 'student') {
        const studentsSignInCardsData = { studentUserProfileIds: userIds, SignInCardPageSizeType: format };
        response = yield call(api.downloadStudentsSignInCards, productId, studentsSignInCardsData);
    } else if (userType === 'teacher') {
        const teacherSignInCardsData = { teacherUserProfileIds: userIds, SignInCardPageSizeType: format };
        response = yield call(api.downloadTeachersSignInCards, productId, teacherSignInCardsData);
    } else {
        const studentSignInCardsData = { ClassroomIds: userIds, SignInCardPageSizeType: format };
        response = yield call(api.downloadClassroomsStudentsSignInCards, { productId, studentSignInCardsData });
    }
    if (response.status === 201) {
        const downloadUrl = `${response.verb.url}/${response.data}`;
        yield put(actions.onRollOverDownloadSignInCardSuccess(downloadUrl, true));
    } else {
        yield put(actions.onRollOverDownloadSignInCardFailure(false));
    }
}

export function* downloadRolloverSignInCardsSaga() {
    yield takeLatest(actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST, downloadRolloverSignInCards);
}



// WEBPACK FOOTER //
// ./app/containers/roll-over/saga.js